import SectionHeader from './SectionHeader';

export default SectionHeader;

export type { ISectionHeaderProps } from './SectionHeader';
